/* eslint-disable no-param-reassign */
import _ from "lodash"
import { createAction, createReducer } from "@reduxjs/toolkit"
import httpClient from "./httpClient"
import appStore from "../appStore"
import uiSlice from "../commons/uiSlice"
import wealthSlice from "../pages/wealth/wealthSlice"
import { PAGE_IDENTIFIER } from "../pages/wealth/pages"

const { actions: ui } = uiSlice
const { actions: wealth } = wealthSlice

const fetchAllResult = createAction("page/fetchAll")
const fetchPagesInfoResult = createAction("page/fetchPagesInfos")
const clear = createAction("page/clear")
const updateOne = createAction("page/updateOne")

function fetchPagesInfos() {
  return (dispatch) =>
    httpClient
      .get("/api/page/info")
      .then(({ data }) => dispatch(fetchPagesInfoResult(data)))
}

function fetchByPageIdentifier(pageIdentifier) {
  return (dispatch) =>
    httpClient.get(`/api/page/${pageIdentifier}`).then(({ data }) => {
      const pageConfigAsMap = { [pageIdentifier]: data }
      dispatch(fetchAllResult(pageConfigAsMap))
    })
}

function create(newPageProperties) {
  return (dispatch) => {
    dispatch(ui.toggleLinearProgress())
    return httpClient
      .post("/api/page", newPageProperties)
      .then(({ data }) => dispatch(updateOne(data)))
      .then(() => dispatch(wealth.clear()))
      .finally(() => dispatch(ui.toggleLinearProgress()))
  }
}

function update(pageProperties) {
  return async (dispatch) => {
    dispatch(ui.toggleLinearProgress())

    try {
      await httpClient.put(`/api/page/${pageProperties._id}`, pageProperties)
      await dispatch(updateOne(pageProperties))
      await dispatch(wealth.clear())
    } finally {
      dispatch(ui.toggleLinearProgress())
    }
  }
}

/**
 * Create a default page instance model instance in frontend by pageId
 * @param pageIdentifier
 * @return instance a page model instance
 */
function valueOf(pageIdentifier) {
  return {
    pageIdentifier,
    title: { fr: undefined, en: undefined },
    isHidden: false,
    limitedToProfile: [],
    dateIsLimited: false
  }
}

/**
 *
 */
const initialState = {
  pagesInfos: undefined,
  pages: {
    [PAGE_IDENTIFIER.overview]: valueOf(PAGE_IDENTIFIER.overview),
    [PAGE_IDENTIFIER.movements]: valueOf(PAGE_IDENTIFIER.movements),
    [PAGE_IDENTIFIER.performance]: valueOf(PAGE_IDENTIFIER.performance),
    [PAGE_IDENTIFIER.composition]: valueOf(PAGE_IDENTIFIER.composition),
    [PAGE_IDENTIFIER.simulations]: valueOf(PAGE_IDENTIFIER.simulations)
  }
}

/**
 * New reducer instance for pages configuration
 */
const reducer = createReducer(initialState, {
  "page/fetchAll": (state, { payload }) => {
    // payload contains map of pages configuration
    // see initial state data structure
    state.pages = _.assign({}, state.pages, payload)
  },
  "page/updateOne": (state, { payload }) => {
    // payload contains one page
    state.pages[payload.pageIdentifier] = payload
    state.pagesInfos[payload.pageIdentifier].isHidden = payload.isHidden
    state.pagesInfos[payload.pageIdentifier].dateIsLimited =
      payload.dateIsLimited
  },
  "page/fetchPagesInfos": (state, { payload }) => {
    state.pagesInfos = payload
  },
  "page/clear": () => initialState
})

/**
 * Inject reducer in main application store
 */
appStore.injectReducer("pages", reducer)

export default {
  actions: { fetchPagesInfos, fetchByPageIdentifier, create, update, clear }
}
